type Props = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

export default function EyeIcon({ className, ...props }: Props) {
  return (
    <svg {...props} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="2.75" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
